const initializeNeighbourhoodMap = () => {
  const mapScrollContainer = document.querySelector('.neighbourhood-map .map-image-scroll-container')
  const mapImage = mapScrollContainer?.querySelector('.map-image')

  if (!mapScrollContainer || !mapImage) {
    return
  }

  const syncInitialScrollPosition = () => {
    const containerWidth = mapScrollContainer.clientWidth
    const mapWidth = Math.max(mapImage.scrollWidth, mapImage.offsetWidth)
    const maxScroll = mapScrollContainer.scrollWidth - containerWidth

    if (mapWidth <= containerWidth || maxScroll <= 0) {
      return
    }

    mapScrollContainer.scrollLeft = maxScroll * 0.7
  }

  requestAnimationFrame(syncInitialScrollPosition)
  window.addEventListener('resize', syncInitialScrollPosition)

  const backgroundImage = mapImage.querySelector('img.background')

  if (backgroundImage && !backgroundImage.complete) {
    backgroundImage.addEventListener('load', syncInitialScrollPosition, { once: true })
  }
}

export const initializeNeighbourhood = () => {
  initializeNeighbourhoodMap()
}